module.exports = __webpack_public_path__ + "img/accessory_hat_13.a5d2a50e.svg";